exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DXykHEDax5MmIG{background-color:#faf3c0;border-radius:4px;display:flex;color:#172b4d;margin-bottom:16px;padding:8px}.DXykHEDax5MmIG ._34Voi9IMmQOuBO{color:#172b4d}.DXykHEDax5MmIG ._34Voi9IMmQOuBO:hover{color:#091e42}.DXykHEDax5MmIG ._1wRFpbIe4G7--Y{font-weight:400;box-shadow:none;margin:0;padding:0;margin-left:auto}.DXykHEDax5MmIG ._1wRFpbIe4G7--Y,.DXykHEDax5MmIG ._1wRFpbIe4G7--Y:active,.DXykHEDax5MmIG ._1wRFpbIe4G7--Y:focus,.DXykHEDax5MmIG ._1wRFpbIe4G7--Y:hover{background:none}", ""]);

// exports
exports.locals = {
	"feedbackContainer": "DXykHEDax5MmIG",
	"feedbackLink": "_34Voi9IMmQOuBO",
	"dismissButtonIcon": "_1wRFpbIe4G7--Y"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/feature-feedback-link.less
// module id = vy9k
// module chunks = 24